<template>
  <div class="List">
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <van-form validate-first @submit="onSubmit">
      <van-field
        v-model="name"
        input-align="right"
        readonly
        :label="isUser ? '客户' : '线索'"
        placeholder="请选择客户来源"
      />
      <van-field
        :value="formdate.type | enumMessage(AllEnums.CRM_FOLLOW_UP_TYPE)"
        input-align="right"
        required
        readonly
        label="跟进类型"
        maxlength="20"
        placeholder="请选择跟进类型"
        @click="openPicker('type')"
        :rules="[{ required: true, message: '请选择跟进类型' }]"
      />
      <van-field
        :value="formdate.nextTime | dateFormat('YYYY-MM-DD')"
        input-align="right"
        required
        readonly
        label="下次联系时间"
        placeholder="请选择下次联系时间"
        @click="openPicker('nextTime')"
        :rules="[{ required: true, message: '请选择下次联系时间' }]"
      />
      <van-field
        v-model.trim="formdate.content"
        input-align="right"
        rows="2"
        required
        autosize
        type="textarea"
        maxlength="100"
        label="跟进内容"
        placeholder="请输入跟进内容"
        show-word-limit
        :rules="[{ required: true, message: '请输入跟进内容' }]"
      />
      <van-field
        name="callRecords"
        label="图片"
        class="form-no-boder"
        label-width="60px"
      >
        <template #input>
          <Uploader
            accept="image/*,video/*,audio/*"
            multiple
            v-model="formdate.picUrls"
          />
        </template>
      </van-field>
      <div class="relation" @click.stop v-if="isUser">
        <van-cell title="关联联系人">
          <template #right-icon>
            <van-button
              name="search"
              @click.stop="
                $router.push('/relation?customerId=' + bizId + '&name=' + name)
              "
              native-type="button"
              type="info"
              size="small"
              class="search-icon"
              >选择</van-button
            >
          </template>
        </van-cell>
        <van-cell
          v-for="(item, index) in contactList"
          :key="index"
          :title="setConcatName(index, item)"
        >
          <van-button
            name="search"
            plain
            size="small"
            type="danger"
            @click="removeRelation(index)"
            class="search-icon"
            >移除</van-button
          >
        </van-cell>
      </div>
      <div class="bottom-btn">
        <div class="btns">
          <van-button
            round
            block
            type="info"
            :disabled="sbumiting"
            native-type="submit"
            >保存</van-button
          >
        </div>
      </div>
    </van-form>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        v-if="['type'].includes(actionType)"
        show-toolbar
        :columns="AllEnums.CRM_FOLLOW_UP_TYPE"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
      <van-datetime-picker
        v-if="['nextTime'].includes(actionType)"
        v-model="currentDate"
        type="date"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import Api from "@/api/user";
// import { eventBus } from "@/plugins/common.js";
import { Form, Field, Toast, Dialog } from "vant";
import { mapMutations, mapState } from "vuex";
Vue.use(Form);
Vue.use(Field);
export default {
  name: "Follow",
  data() {
    return {
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      formdate: {},
      showPicker: false,
      actionType: "",
      sbumiting: false,
      contactList: [],
    };
  },
  computed: {
    ...mapState(["relationList"]),
    bizId() {
      return this.$route.query.bizId;
    },
    isUser() {
      return this.$route.query.type == "user";
    },
    name() {
      return this.$route.query.name;
    },
    title() {
      return this.isUser ? "客户跟进" : "线索跟进";
    },
  },
  activated() {
    this.contactList = this.relationList;
    this.setRelationList([]);
  },
  methods: {
    ...mapMutations(["setRelationList"]),
    async onSubmit() {
      await this.createFollow();
    },
    // 创建跟进
    async createFollow() {
      if (this.sbumiting) return;
      try {
        this.sbumiting = true;
        await Api.createFollow({
          ...this.formdate,
          contactIds: this.contactList.map((item) => item.id),
          bizType: this.isUser ? 2 : 1,
          type: Number(this.formdate.type),
          bizId: this.bizId,
        });
        Toast.success("跟进成功");
        this.resetData();
        setTimeout(() => {
          this.sbumiting = false;
          this.$router.go(-1);
        }, 1500);
      } catch (error) {
        this.sbumiting = false;
        Toast.fail(error);
      }
    },

    openPicker(actionType) {
      this.actionType = actionType;
      this.showPicker = true;
    },

    onConfirm(value) {
      if (this.actionType == "nextTime") {
        this.formdate[this.actionType] = new Date(value).getTime();
      } else {
        this.formdate[this.actionType] = value.value;
      }
      this.showPicker = false;
    },

    removeRelation(index) {
      Dialog.confirm({
        title: "提示",
        message: "确定要移除吗？",
      })
        .then(async () => {
          this.contactList.splice(index, 1);
        })
        .catch(() => {
          // on cancel
        })
        .catch(() => {
          // on cancel
        });
    },
    setConcatName(index, i) {
      let { name, post, mobile } = i;
      return `${index + 1}、${[name, post, mobile].filter(Boolean).join("-")}`;
    },

    resetData() {
      this.formdate = {};
      this.contactList = [];
    },

    onClickLeft() {
      this.resetData();
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-uploader__upload {
  background: #efefef;
}
.relation {
  /deep/.van-cell {
    .van-cell__title {
      display: flex;
      align-items: center;
    }
    .van-cell__value {
      flex: 0 0 80px;
    }
  }
}
</style>
